export default __webpack_public_path__ + "arrowheads-pointing-to-the-left.png";